import React, { useEffect, useState } from 'react';
import { SocialLinks } from './SocialLinks';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <header className="relative" data-id="element-70">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6'}`} data-id="element-71">
        <div className="container-padding mx-auto flex justify-between items-center" data-id="element-72">
          <a href="#" className="font-display font-bold text-xl" data-id="element-73">
            Sai Akhil M.
          </a>
          <div className="hidden md:flex items-center space-x-8" data-id="element-74">
            <a href="#startups" className="hover:text-primary transition-colors" data-id="element-75">
              Startups
            </a>
            <a href="#projects" className="hover:text-primary transition-colors" data-id="element-76">
              Projects
            </a>
            <a href="#experience" className="hover:text-primary transition-colors" data-id="element-77">
              Experience
            </a>
            <a href="#education" className="hover:text-primary transition-colors" data-id="element-78">
              Education
            </a>
            <a href="#contact" className="btn-primary" data-id="element-79">
              Contact
            </a>
          </div>
          <button className="md:hidden text-secondary" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-80">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-81" /> : <MenuIcon size={24} data-id="element-82" />}
          </button>
        </div>
        {/* Mobile menu */}
        {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-md py-4 px-6 flex flex-col space-y-4" data-id="element-83">
            <a href="#startups" className="hover:text-primary transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-84">
              Startups
            </a>
            <a href="#projects" className="hover:text-primary transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-85">
              Projects
            </a>
            <a href="#experience" className="hover:text-primary transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-86">
              Experience
            </a>
            <a href="#education" className="hover:text-primary transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-87">
              Education
            </a>
            <a href="#contact" className="btn-primary inline-block text-center" onClick={() => setMobileMenuOpen(false)} data-id="element-88">
              Contact
            </a>
          </div>}
      </nav>
      {/* Hero Section */}
      <div className="pt-32 pb-20 md:pt-44 md:pb-32 container-padding bg-gradient-to-b from-tertiary to-background-light" data-id="element-89">
        <div className="max-w-5xl mx-auto" data-id="element-90">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-91">
            <div className="md:w-2/3" data-id="element-92">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-bold mb-6" data-id="element-93">
                Sai Akhil Madurakavi
              </h1>
              <h2 className="text-xl md:text-2xl font-medium text-primary mb-4" data-id="element-94">
                Entrepreneur | Hardware + AI Engineer |
                EE Student
              </h2>
              <p className="text-lg md:text-xl text-text-secondary mb-8 max-w-3xl" data-id="element-95">
                Building innovative AI and hardware solutions at the
                intersection of IoT, Apps, Product Design, Robotics, and Neural Engineering.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-96">
                <a href="#startups" className="btn-primary text-center" data-id="element-97">
                  View My Work
                </a>
                <a href="#contact" className="btn-secondary text-center" data-id="element-98">
                  Get In Touch
                </a>
              </div>
              <div className="mt-10" data-id="element-99">
                <p className="text-text-secondary mb-2" data-id="element-100">
                  Bay Area, California
                </p>
                <SocialLinks data-id="element-101" />
              </div>
            </div>
            <div className="mt-10 md:mt-0 md:w-1/3 flex justify-center md:justify-end" data-id="element-102">
              <div className="w-48 h-48 md:w-64 md:h-64 rounded-full overflow-hidden border-4 border-white shadow-lg" data-id="element-103">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d5pq2R3kykKaUogawaCdmL/IMG_8851_Copy.jpg" alt="Sai Akhil Madurakavi" className="w-full h-full object-cover" data-id="element-104" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>;
}